import _ from "lodash";
import { UniAnswer } from "../../dao/UniAnswer";
import { UniForm } from "../../dao/UniForm";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { Table, UNKNOWN, CommonExportUtil as Util } from "./CommonExportUtil";
import { Project } from "../../dao/Project";
import { Member } from "../../dao/Member";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";



export class F02_ExportManager {

  static Export_F02v0(common_form: UniForm, meta_table: UiMetaTable, answer_list: UniAnswer[], _Project: Project, sel_member_list: Member[]): F02_ExportData[] {
    let export_list: F02_ExportData[] = [];

    for (const ans of answer_list) {
      let sel_ans_member = sel_member_list.find(member => member.guid === ans.member_guid) //取得該ans的member資料

      let rhf_data = ans.ConvertToCommonRhfData();

      let export_data: F02_ExportData = new F02_ExportData();

      //#region 帶入基本資料
      export_data.填寫日期 = Util.填寫日期(ans);

      export_data.項次 = Util.項次();

      export_data.廠區 = Util.廠區(_Project);
      export_data.部門代號 = Util.部門代號();
      export_data.部門名稱 = Util.部門名稱(sel_ans_member);

      export_data.工號 = Util.工號(sel_ans_member);
      export_data.姓名 = Util.姓名(sel_ans_member);
      export_data.健檢日期 = Util.健檢日期(sel_ans_member);

      export_data.性別 = Util.性別(ans, sel_ans_member);
      //#endregion

      let 頻率RULE: Table = {
        "沒有或極少": "0",
        "有時": "1",
        "時常": "2",
        "常常/總是": "3",
      }

      export_data.Q1_我常常覺得想哭 = Util.OptionValue(meta_table, rhf_data, "m01.覺得想哭", UNKNOWN, 頻率RULE);// 1
      export_data.Q2_我覺得心情不好 = Util.OptionValue(meta_table, rhf_data, "m01.心情不好", UNKNOWN, 頻率RULE);// 2
      export_data.Q3_我覺得比以前容易發脾氣 = Util.OptionValue(meta_table, rhf_data, "m01.容易發脾氣", UNKNOWN, 頻率RULE);// 3
      export_data.Q4_我睡不好 = Util.OptionValue(meta_table, rhf_data, "m02.睡不好", UNKNOWN, 頻率RULE);// 4
      export_data.Q5_我覺得不想吃東西 = Util.OptionValue(meta_table, rhf_data, "m02.不想吃東西", UNKNOWN, 頻率RULE);// 5

      export_data.Q6_我覺得胸口悶悶的 = Util.OptionValue(meta_table, rhf_data, "m02.胸口悶悶的", UNKNOWN, 頻率RULE);// 6
      export_data.Q7_我覺得不輕鬆不舒服 = Util.OptionValue(meta_table, rhf_data, "m03.不舒服", UNKNOWN, 頻率RULE);// 7
      export_data.Q8_我覺得身體疲勞虛弱無力 = Util.OptionValue(meta_table, rhf_data, "m03.疲勞虛弱無力", UNKNOWN, 頻率RULE);// 8
      export_data.Q9_我覺得很煩 = Util.OptionValue(meta_table, rhf_data, "m03.覺得很煩", UNKNOWN, 頻率RULE);// 9
      export_data.Q10_我覺得記憶力不好 = Util.OptionValue(meta_table, rhf_data, "m04.記憶力不好", UNKNOWN, 頻率RULE);// 10

      export_data.Q11_我覺得做事時無法專心 = Util.OptionValue(meta_table, rhf_data, "m04.無法專心", UNKNOWN, 頻率RULE);// 11
      export_data.Q12_我覺得想事情或做事時比平常要緩慢 = Util.OptionValue(meta_table, rhf_data, "m04.思考變緩慢", UNKNOWN, 頻率RULE);// 12
      export_data.Q13_我覺得比以前沒信心 = Util.OptionValue(meta_table, rhf_data, "m05.沒信心", UNKNOWN, 頻率RULE);// 13
      export_data.Q14_我覺得比較會往壞處想 = Util.OptionValue(meta_table, rhf_data, "m05.往壞處想", UNKNOWN, 頻率RULE);// 14
      export_data.Q15_我覺得想不開甚至想死 = Util.OptionValue(meta_table, rhf_data, "m05.想不開", UNKNOWN, 頻率RULE);// 15

      export_data.Q16_我覺得對什麼事都失去興趣 = Util.OptionValue(meta_table, rhf_data, "m06.失去興趣", UNKNOWN, 頻率RULE);// 16
      export_data.Q17_我覺得身體不舒服 = Util.OptionValue(meta_table, rhf_data, "m06.身體不適", UNKNOWN, 頻率RULE);// 17
      export_data.Q18_我覺得自己很沒用 = Util.OptionValue(meta_table, rhf_data, "m06.覺得沒用", UNKNOWN, 頻率RULE);// 18

      export_data.總分 = F02_ExportManager.計算總分(export_data);
      export_data.說明 = F02_ExportManager.顯示說明文字(export_data.總分);

      export_list.push(export_data);
    }

    return export_list;
  }

  static 計算總分(export_data: F02_ExportData) {

    let score = 0;

    score += Number(export_data.Q1_我常常覺得想哭);
    score += Number(export_data.Q2_我覺得心情不好);
    score += Number(export_data.Q3_我覺得比以前容易發脾氣);
    score += Number(export_data.Q4_我睡不好);
    score += Number(export_data.Q5_我覺得不想吃東西);

    score += Number(export_data.Q6_我覺得胸口悶悶的);
    score += Number(export_data.Q7_我覺得不輕鬆不舒服);
    score += Number(export_data.Q8_我覺得身體疲勞虛弱無力);
    score += Number(export_data.Q9_我覺得很煩);
    score += Number(export_data.Q10_我覺得記憶力不好);

    score += Number(export_data.Q11_我覺得做事時無法專心);
    score += Number(export_data.Q12_我覺得想事情或做事時比平常要緩慢);
    score += Number(export_data.Q13_我覺得比以前沒信心);
    score += Number(export_data.Q14_我覺得比較會往壞處想);
    score += Number(export_data.Q15_我覺得想不開甚至想死);

    score += Number(export_data.Q16_我覺得對什麼事都失去興趣);
    score += Number(export_data.Q17_我覺得身體不舒服);
    score += Number(export_data.Q18_我覺得自己很沒用);

    if (isNaN(score)) {
      return UNKNOWN;
    } else {
      return String(Math.round(score));
    }

  }

  static 顯示說明文字(score: string) {
    let score_to_number_type = Number(score); // 轉成number型別
    if (isNaN(score_to_number_type)) {
      return UNKNOWN;
    } else if (score_to_number_type >= 0 && score_to_number_type <= 8) {
      return "情緒穩定";
    } else if (score_to_number_type >= 9 && score_to_number_type <= 14) {
      return "情緒較不穩定、多注意情緒變化，多給自己關心";
    } else if (score_to_number_type >= 15 && score_to_number_type <= 18) {
      return "壓力負荷已到極點，需要找朋友交談、舒緩情緒";
    } else if (score_to_number_type >= 19 && score_to_number_type <= 54) { //18個題目每題都是最高的3分, 最多54分
      return "必須找專業醫療單位協助";
    } else {
      throw new_ErrorAlert('486289 score 不在範圍內');
    }
  }

}

export class F02_ExportData {
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";

  //-----

  Q1_我常常覺得想哭 = "";
  Q2_我覺得心情不好 = "";
  Q3_我覺得比以前容易發脾氣 = "";
  Q4_我睡不好 = "";
  Q5_我覺得不想吃東西 = "";

  Q6_我覺得胸口悶悶的 = "";
  Q7_我覺得不輕鬆不舒服 = "";
  Q8_我覺得身體疲勞虛弱無力 = "";
  Q9_我覺得很煩 = "";
  Q10_我覺得記憶力不好 = "";

  Q11_我覺得做事時無法專心 = "";
  Q12_我覺得想事情或做事時比平常要緩慢 = "";
  Q13_我覺得比以前沒信心 = "";
  Q14_我覺得比較會往壞處想 = "";
  Q15_我覺得想不開甚至想死 = "";

  Q16_我覺得對什麼事都失去興趣 = "";
  Q17_我覺得身體不舒服 = "";
  Q18_我覺得自己很沒用 = "";

  //----

  總分 = "";
  說明 = "";
}

